/**
 * Link curto do cardápio (/c/:alias).
 *
 * Mora num lugar só: o documento da própria loja, em `merchants/{id}.linkCardapio`
 * ({ alias, cliques, ultimoAcesso, criadoEm }). Antes eram dois — a coleção
 * `shortLinks/{alias}` e o campo `merchants/{id}.alias` — e eles se desencontravam:
 * o registro em `shortLinks` sumiu e o link da loja passou a dar "não encontrado"
 * com o apelido ainda gravado na loja.
 *
 * Mesma regra no backend: Auuii-Backend/src/services/linkCardapio.js.
 */

export const ALIAS_MIN = 3;
export const ALIAS_MAX = 30;

/** Enquanto a pessoa digita: minúsculas, sem acento, espaço vira hífen, só [a-z0-9-]. */
export function normalizarAlias(valor) {
  return String(valor ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-/, '')
    .slice(0, ALIAS_MAX);
}

/** Na hora de salvar/buscar: igual ao de cima, sem hífen sobrando no fim. */
export function limparAlias(valor) {
  return normalizarAlias(valor).replace(/-+$/, '');
}

export function aliasValido(alias) {
  return typeof alias === 'string'
    && alias.length >= ALIAS_MIN
    && alias.length <= ALIAS_MAX
    && /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(alias);
}

/** Apelido da loja — o campo novo, ou o antigo `alias` de quem ainda não migrou. */
export function aliasDaLoja(loja) {
  return loja?.linkCardapio?.alias || loja?.alias || '';
}

/** Visualizações e último acesso, para o cartão do link no painel. */
export function estatisticasDoLink(loja) {
  const link = loja?.linkCardapio || {};
  const ultimo = link.ultimoAcesso;
  return {
    clicks: Number(link.cliques) || 0,
    lastAccess: ultimo?.toDate ? ultimo.toDate() : (ultimo ? new Date(ultimo) : null),
  };
}
